module.exports = __webpack_public_path__ + "img/404.b6c690df.png";